function initStockInfo() {
  const stockConsent = document.getElementById("footerStockConsent");
  const stockOptInButton = document.getElementById("footerStockOptIn");
  const stockLoader = document.getElementById("footerStockLoader");
  const dynamicContent = document.getElementById("footerStockDynamicContent");
  const stockValueAmount = document.getElementById("footerStockValueAmount");
  const stockValuePercent = document.getElementById("footerStockValuePercent");
  const stockValuePercentInner = document.getElementById(
    "footerStockValuePercentInner"
  );
  const stockDateFetchedElement = document.getElementById("footerStockDate");

  if (
    !stockConsent ||
    !stockOptInButton ||
    !stockLoader ||
    !dynamicContent ||
    !stockValueAmount ||
    !stockValuePercent ||
    !stockValuePercentInner ||
    !stockDateFetchedElement
  ) {
    console.warn("Elemente für Aktienkurs-Info nicht gefunden. Skript wird nicht ausgeführt.");
    return;
  }

  let hasFetched = false;

  const fetchAndDisplayStockInfo = async () => {
    if (hasFetched) {
      return;
    }
    hasFetched = true;

    stockConsent.style.display = "none";
    stockLoader.style.display = "block";

    try {
      const response = await fetch(
        "https://charts3.equitystory.com/api-json/ecotel/English"
      );
      if (!response.ok) {
        throw new Error(`HTTP-Fehler! Status: ${response.status}`);
      }
      const jsonData = await response.json();

      stockLoader.style.display = "none";
      dynamicContent.classList.add("loaded");

      const relativeStockChange = typeof jsonData.change_relative === "string" ? parseFloat(jsonData.change_relative.replace("%", "")) : jsonData.change_relative
      const stockChangeClass = relativeStockChange < 0 ? 'falling' : 'rising';
      stockValuePercent.classList.add(stockChangeClass);

      const numberFormatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      stockValueAmount.textContent = numberFormatter.format(jsonData.last_price);
      const percentFormatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        signDisplay: 'exceptZero',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
      stockValuePercentInner.textContent = `${percentFormatter.format(parseFloat(jsonData.change_relative))}%`;

      const stockDate = new Date(jsonData.time_last_price * 1000);
      const datePart = new Intl.DateTimeFormat('de-DE', {
        day: '2-digit', month: '2-digit', year: 'numeric'
      }).format(stockDate);
      const timePart = new Intl.DateTimeFormat('de-DE', {
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZone: 'Europe/Berlin'
      }).format(stockDate);

      stockDateFetchedElement.textContent = `${datePart} / ${timePart} CET`;

    } catch (error) {
      console.error("Fehler beim Abrufen der Aktien-Infos:", error);
      stockLoader.style.display = 'none';
    }
  };

  const SERVICE_ID = '5TzmZEakZd5F96';

  const checkConsentAndFetch = () => {
    if (hasFetched) {
      return;
    }

    if (typeof window.UC_UI?.getServicesBaseInfo !== 'function') {
      return;
    }

    const services = window.UC_UI.getServicesBaseInfo();
    const stockService = services.find(service => service.id === SERVICE_ID);

    if (stockService?.consent?.status) {
      fetchAndDisplayStockInfo();
    }
  };

  stockOptInButton.addEventListener('click', () => {
    if (typeof window.UC_UI?.acceptService !== 'function') {
      console.warn('Usercentrics acceptService function is not available.');
      stockConsent.style.display = 'none';
      return;
    }
    window.UC_UI.acceptService(SERVICE_ID);
  });

  window.addEventListener('UC_UI_INITIALIZED', checkConsentAndFetch, { once: true });
  window.addEventListener('uc_consent_update', checkConsentAndFetch);
  if (typeof window.UC_UI !== 'undefined') {
    checkConsentAndFetch();
  }
}

initStockInfo();
